module.exports = __webpack_public_path__ + "img/doc.bb282692.png";